import HoverMenu from 'material-ui-popup-state/HoverMenu';
import styled from 'styled-components';

import {
  AppBar,
  Button,
  Container,
  Link,
  ListSubheader,
  MenuItem,
  Toolbar,
} from '@mui/material';

export const NavbarContainer = styled(AppBar)`
  background-color: #fff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  height: 88px;
  z-index: 1;
`;

export const WrapperContainer = styled(Container)`
  align-items: center;
  justify-content: space-between;
  text-align: center;
  height: 100%;
`;

export const ToolbarContainer = styled(Toolbar)`
  height: 100%;
  justify-content: space-between;
`;

export const WrapperLogo = styled.div``;

export const Logo = styled.img`
  height: 50px;
  margin: auto 0;
`;

export const LinksContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LinkItem = styled(Link)`
  font-weight: 700;
  font-family: 'Roboto', sans-serif;
  transition: all 0.2s ease;
  color: #263c6a;
  &:hover {
    color: #18afe6;
  }
  margin-left: 30px;
  text-decoration: none;
`;

export const ButtonDropdown = styled(Button)`
  font-weight: 700;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  transition: all 0.2s ease;
  color: #263c6a;
  &:hover,
  &:active,
  &:focus {
    color: #18afe6;
    background-color: transparent;
  }
  margin-left: 30px;
  text-transform: none;
  &:last-child {
    color: #18afe6;
    &:hover {
      color: #1a7592;
    }
    & DropdownMenu {
      & DropdownItem {
        color: #18afe6;
      }
    }
  }
`;

export const DropdownMenu = styled(HoverMenu)`
  display: flex;
  flex-direction: column;
  position: absolute;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  & .MuiPaper-root {
    border-radius: 0px;
    width: auto;
    min-width: 150px;
  }
  & .MuiList-root {
    padding: 0px;
  }
`;

export const DropdownItem = styled(MenuItem)`
  padding: 0.5rem 1rem;
  padding-left: 2rem;
  transition: all 0.2s ease;
  cursor: pointer;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  color: #18afe6;
  background-color: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  &:hover {
    color: #ffffff;
    background-color: #263c6a;
  }
`;

export const DropdownItemLink = styled(Link)`
  text-decoration: none;
`;

export const DropdownItemLabel = styled(ListSubheader)`
  padding: 0.5rem 1rem;
  line-height: unset;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  color: #263c6a;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
